import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
const links = [{
  label: 'Términos y Condiciones',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}];
export function Footer() {
  return <footer className="bg-navy" data-id="element-69" data-mp="32pfc42m3b1ty">
      <div className="mx-auto max-w-2xl px-4 py-4 pb-20 text-center sm:pb-5" data-id="element-70" data-mp="36pfsvtwnvp46">
        <p className="text-xs text-white/85" data-id="element-71" data-mp="36nd57gize82m">© 2026 — Todos los Derechos Reservados.</p>
        <p className="mt-1 text-[0.66rem] leading-snug text-white/70" data-id="element-72" data-mp="3uftmhouw9w0v">
          {PRODUCT_NAME}™ es un producto educativo. El material funciona como recurso complementario y no sustituye
          formación profesional o docente, prácticas supervisadas, documentación oficial de fabricantes, normativa
          eléctrica y de seguridad aplicable, certificaciones, permisos ni el criterio de profesionales habilitados.
          Toda práctica con instalaciones, motores, tableros, automatismos o equipos eléctricos debe realizarse bajo
          condiciones adecuadas de seguridad y supervisión correspondiente.
        </p>
        <p className="mt-1 text-xs text-white/85" data-id="element-73" data-mp="3lbdc0r0ka5kr">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-volt underline-offset-2 transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-white hover:underline" data-id="element-74" data-mp="3gca5t38uhtb7">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1" data-id="element-75" data-mp="81fqhygiyw59">
          <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-white/85" data-id="element-76" data-mp="34gx5i4oqt84">
            {links.map((link, i) => <li key={link.label} className="flex items-center gap-2" data-id="element-77" data-mp="hs1vyzuj26a8" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" data-id="element-78" data-mp="cu8tohwchwf8">•</span>}
                <a href={link.href} className="whitespace-nowrap transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-volt" data-id="element-79" data-mp="qt8ipqnrsdbx">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </footer>;
}